import { render } from "./Auth.vue?vue&type=template&id=79648b24&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import "@/assets/themes/assets/css/pages/login/classic/login-5.css?vue&type=style&index=0&id=79648b24&scoped=true&lang=css"

import exportComponent from "E:\\project.kinnections\\kinnections-spa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79648b24"]])

export default __exports__